export var isFailaConfig = function (config) { return config.isFailaConfig; };
export var isConfigDisabled = function (config) { return isFailaConfig(config); };
export var isAZFailureNear = function (config) {
    var nextTriggerTime = new Date(config === null || config === void 0 ? void 0 : config.nextTrigger).getTime();
    if (!nextTriggerTime ||
        isNaN(nextTriggerTime) ||
        config.nextTrigger === "Excluded") {
        return false;
    }
    var currentUtcTime = new Date().getTime();
    var timeDifferenceInMilliseconds = nextTriggerTime - currentUtcTime;
    var sevenDaysInMilliseconds = 7 * 24 * 60 * 60 * 1000;
    return timeDifferenceInMilliseconds < sevenDaysInMilliseconds;
};
export var CronosFilterOptions = {
    environment: [
        { label: "ddev", value: "ddev" },
        { label: "dev-west2", value: "dev-west2" },
        { label: "adev", value: "adev" },
        { label: "adev-west2", value: "adev-west2" },
        { label: "stg-east", value: "stg-east" },
        { label: "stg-west", value: "stg-west" },
        { label: "stg-west2", value: "stg-west2" },
        { label: "stg-euwest", value: "stg-euwest" },
        { label: "stg-eucentral", value: "stg-eucentral" },
        { label: "stg-apse", value: "stg-apse" },
        { label: "stg-apse2", value: "stg-apse2" },
        { label: "stg-cacentral", value: "stg-cacentral" },
        { label: "stg-eucentral2", value: "stg-eucentral2" },
        { label: "prod-east", value: "prod-east" },
        { label: "prod-west", value: "prod-west" },
        { label: "prod-west2", value: "prod-west2" },
        { label: "prod-cacentral", value: "prod-cacentral" },
        { label: "prod-saeast", value: "prod-saeast" },
        { label: "prod-euwest", value: "prod-euwest" },
        { label: "prod-euwest2", value: "prod-euwest2" },
        { label: "prod-eucentral", value: "prod-eucentral" },
        { label: "prod-eucentral2", value: "prod-eucentral2" },
        { label: "prod-apse", value: "prod-apse" },
        { label: "prod-apse2", value: "prod-apse2" },
        { label: "prod-apne", value: "prod-apne" },
        { label: "prod-apne2", value: "prod-apne2" },
        { label: "prod-eucentral2", value: "prod-eucentral2" },
        { label: "prod-apsouth", value: "prod-apsouth" }
    ],
    wargameTemplateName: [
        {
            label: "Dynamic template for continuous-chaos: terminate instances fault",
            value: "Dynamic template for continuous-chaos: terminate instances fault"
        },
        {
            label: "Dynamic template for continuous-chaos: az_failure fault",
            value: "Dynamic template for continuous-chaos: az_failure fault"
        }
    ],
    status: [
        { label: "error", value: "error" },
        { label: "failed", value: "failed" },
        { label: "user_abort", value: "user_abort" },
        { label: "completed", value: "completed" }
    ]
};
